import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormArray, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {EmTranslatePipe, TranslationService} from '@emma-labs/shared/angular';
import {INSURANCE_COMPANY_SELECT_BUTTONS} from '@emma-labs/shared/typescript';
import {NgxMaskDirective} from 'ngx-mask';
import {Button, ButtonDirective} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {RecommendationForm} from '../quote-comparator.component';

@Component({
  selector: 'em-recommendations-section',
  templateUrl: './recommendations-section.component.html',
  imports: [
    CardModule,
    ReactiveFormsModule,
    DropdownModule,
    NgxMaskDirective,
    InputTextareaModule,
    Button,
    CheckboxModule,
    ButtonDirective,
    InputTextModule,
    EmTranslatePipe,
  ],
})
export class QuoteComparatorRecommendationsSectionComponent {
  @Input({required: true}) recommendationsForm!: FormArray<FormGroup<RecommendationForm>>;
  @Output() productSectionAdded = new EventEmitter<number>();
  @Output() productSectionDeleted = new EventEmitter<{
    recommendationsFormIndex: number;
    productFormIndex: number;
  }>();
  @Output() recommendationSectionAdded = new EventEmitter<undefined>();
  @Output() recommendationSectionDeleted = new EventEmitter<number>();

  readonly companyOptions = INSURANCE_COMPANY_SELECT_BUTTONS;
  readonly isFr: boolean;

  constructor(private readonly translate: TranslationService) {
    this.isFr = this.translate.currentLanguageIsFr();
  }

  addProduct(index: number) {
    this.productSectionAdded.emit(index);
  }

  removeProduct(i: number, j: number) {
    this.productSectionDeleted.emit({recommendationsFormIndex: i, productFormIndex: j});
  }

  removeRecommandationSection(i: number) {
    this.recommendationSectionDeleted.emit(i);
  }

  addRecommendation() {
    this.recommendationSectionAdded.emit();
  }
}
